import { V2ListBlueprintsForAccountApiArg } from "@generated";
import useListBlueprints from "../../../../Projects/ServicesV2/Blueprints/api/useListBlueprints";

export type { Blueprint } from "../../../../Projects/ServicesV2/types";

interface Params {
  filter?: V2ListBlueprintsForAccountApiArg["filter"];
  page?: { number: number; size: number };
}

const useListBlueprintsForAccount = ({ filter, page }: Params = {}) => {
  const { blueprints, isLoading, isFetching, pageMeta, refetch } =
    useListBlueprints({
      filterParams: filter,
      pageSize: page?.size ?? 10,
      currentPage: page?.number ?? 1,
      sortBy: undefined,
      sortOrder: undefined,
    });

  return {
    blueprints,
    blueprintsLoading: isLoading,
    blueprintsFetching: isFetching,
    pageMeta,
    refetch,
  };
};

export default useListBlueprintsForAccount;
